<ng-container *ngIf="(publicationsWidget$ | async)?.length > 0 && (publicationsWidget$ | async); let publications;">
  <mat-card mat-align-tabs="center" class="m-b-16" style="padding: 0px;background-color: transparent;">
    <mat-card-title><h2>{{ 'general.last_news' | translate }}</h2></mat-card-title>
    <mat-card-content>
      <div *ngFor="let publication of publications; let i = index"  style="width:100%;">
        <widget-publication-tile
        [publication]="publication"
        [first]="i === 0"
        [widget]="true">
      </widget-publication-tile>
    </div>
    <!-- <div  style="width: 100%;text-align:center; margin-top:0px;">
      <button mat-button color="primary" [routerLink]="sharedService.buildRoute(['news'])">{{ 'general.show_more' | translate }} {{ 'ROUTES.news' | translate }}</button>
    </div> -->
    </mat-card-content>
  </mat-card>
</ng-container>


